import { useEffect } from "react";
import { Form, Input, Button } from "antd";
import { Link } from 'react-router-dom'
import FormControl from "../../component/form/FormControl";
import Service from '../../service/Auth'
import Swal from "sweetalert2";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

export default function FormResetPassword(props) {

    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue({});
    }, [form]);

    const onFinish = async (values) => {
        values.token = props.token
        let result = await Service.forgetPwdResetPassword(values)
        if(result){
            Swal.fire({
                title: "สำเร็จ",
                icon: "success",
                timer: 3000
            }).then((resp, err)=>{
                window.location.href = "/"
            })
        }
    }

    const validateConfirmPassword = (rule, value, callback) =>
        value == form.getFieldValue("password")
            ? Promise.resolve()
            : Promise.reject(new Error("รหัสผ่านไม่ตรงกัน"));

    const formInput = () => {
        return (
            <>
                <Form.Item
                    name={["password"]}
                    className="form-item__new-password"
                    label="รหัสผ่าน"
                    rules={[{ required: true }]}
                >
                    <Input.Password />
                </Form.Item>
                <Form.Item
                    name={["confirmPassword"]}
                    className="form-item__confirm-new-password"
                    label="ยืนยันรหัสผ่าน"
                    rules={[{ required: true }, { validator: validateConfirmPassword }]}
                >
                    <Input.Password />
                </Form.Item>
                <Form.Item className="form-button">
                    <Button
                        className="form-item__btn-submit btn-primary"
                        htmlType="submit"
                    >
                        ยืนยัน
                    </Button>
                    <Button
                        className="form-item__btn-submit btn-secondary"
                    ><Link to="/">ยกเลิก</Link>
                    </Button>
                </Form.Item>
            </>
        );
    };

    return (
        <FormControl
            name={"form-reset-password"}
            column={1}
            inputs={formInput}
            onFinish={props.onFinish ? props.onFinish : onFinish}
            form={form}
            className={props.className ? props.className : ""}
        ></FormControl>
    );
}